import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/common-items/services/helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  title = 'ConnectPay Login';
  isLoadApp: boolean = false;  
  isTimeOutHappened: boolean = false;
  isShowheaderFooter = true;
  constructor(public translate: TranslateService, private helperService:HelperService) {
     this.helperService.pageNotFoundSubs.subscribe((res : boolean) =>{ 
      this.isShowheaderFooter = res;
     })
    
    // this language will be used as a fallback when a translation isn't found in the current language
     translate.setDefaultLang('en');

     // the lang to use, if the lang isn't available, it will use the current loader to get them
     translate
     .use('en')
     .subscribe((res: any) => 
     {
         this.isLoadApp = true;
     });
  }

  ngOnInit() {
  }
}
